import { dadosSequenciaisStyles } from './DadosSequenciais.style'

export function dadosSequenciaisIO() {
  return {
    styles: dadosSequenciaisStyles
  }
}

export type DadosSequenciaisIO = ReturnType<typeof dadosSequenciaisIO>
